import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Observer } from 'rxjs/Observer';

export class BaseManagement {
	id: any;
	isNew: boolean = false;
	form: any;

	constructor(
	){
		this.working = {
			isWorking: false,
			action: ''
		};
	}

	working: {
		isWorking: boolean,
		action: any
	}

	isWorking(){
		return this.working.isWorking;
	}	

	isWorkingByAction(action){
		return this.working.isWorking && this.working.action == action;
	}		

	startWorking(action){
		this.working = {
			isWorking: true,
			action: action
		};
	}

	stopWorking(){
		this.working = {
			isWorking: false,
			action: ""
		};		
	}	
};	


// WEBPACK FOOTER //
// ./src/providers/base-management.ts